import { MapPin, Navigation, Phone } from "lucide-react";
import { telHref } from "@/lib/api";
import { SectionHeading } from "./kit";

export const Location = ({ content }) => {
  const embed = `https://www.google.com/maps?q=${encodeURIComponent(content.location_address || "")}&output=embed`;
  return (
    <section id="location" className="relative bg-red-950/40 px-5 py-20 md:py-28" data-testid="location-section">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1fr_1.2fr]">
        <div>
          <SectionHeading eyebrow="Where" title="Find the" accent="compound" />
          <div className="space-y-6">
            <div className="flex gap-4">
              <MapPin className="mt-1 h-6 w-6 shrink-0 text-amber-400" />
              <div>
                <p className="font-display text-2xl text-neutral-50" data-testid="location-name">{content.location_name}</p>
                <p className="mt-1 text-neutral-300" data-testid="location-address">{content.location_address}</p>
              </div>
            </div>
            <a
              href={content.maps_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-maps-link"
              className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-6 py-3 font-display font-semibold text-neutral-950 transition-transform duration-200 hover:-translate-y-0.5"
            >
              <Navigation className="h-4 w-4" /> Open in Google Maps
            </a>
            <div className="rounded-lg border border-emerald-800/60 bg-neutral-950/70 p-5">
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-emerald-400">Questions & vending</p>
              <a href={telHref(content.contact_phone)} data-testid="location-contact-phone" className="mt-2 flex items-center gap-3 font-display text-2xl text-gold hover:text-amber-300">
                <Phone className="h-5 w-5" /> {content.contact_name} {content.contact_phone}
              </a>
              <p className="mt-1 text-sm text-neutral-400">{content.contact_note} · <a href="#vendor" className="font-semibold text-amber-400 hover:underline" data-testid="location-vendor-link">vendor application</a></p>
            </div>
          </div>
        </div>
        <div className="overflow-hidden rounded-lg border border-neutral-800">
          <iframe title="Map to Ilesa Ire Compound" src={embed} className="h-72 w-full grayscale-[40%] lg:h-full lg:min-h-[420px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="location-map" />
        </div>
      </div>
    </section>
  );
};
